import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  inject,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-form-element',
  templateUrl: './form-element.component.html',
  styleUrls: ['./form-element.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, TranslatePipe],
  host: { class: 'flex flex-col' },
})
export class FormElementComponent implements OnDestroy, OnChanges {
  private translateService = inject(TranslateService);
  private changeDetectorRef = inject(ChangeDetectorRef);

  error = '';
  @Input() id!: string;
  @Input() label?: string;
  @Input() twoColumns = false;
  @Input() required = false;
  @Input() control?: FormControl;
  private subscription?: Subscription;

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.control) {
      this.subscription?.unsubscribe();
      if (this.control) {
        this.subscription = this.control.statusChanges.subscribe(() => {
          this.error = Object.keys(this.control?.errors ?? {})
            .map((key) => this.translateService.instant('ERRORS.' + key))
            .join(' ');
          this.changeDetectorRef.markForCheck();
        });
      }
    }
  }
}
